/**
 * @flow
 *
 * @format
 */

export const NOTIF_ADD = 'notifications/NOTIF_ADD';
export const NOTIF_REMOVE = 'notifications/NOTIF_REMOVE';
export const NOTIF_CLEANUP = 'notifications/NOTIF_CLEANUP';
